import Vue from 'vue'
import Toast from './index.vue'

let newInstance = null
const ToastConstructor = Vue.extend(Toast)

const init = propsData => {
  newInstance = new ToastConstructor({
    propsData
  })
  // 使用$mount()后  可以理解为创建虚拟的dom
  document.body.appendChild(newInstance.$mount().$el)
}

const callback = (message, duration=3000) => {
  if (!newInstance) {
    init({message, duration})
  }
  newInstance.show()
  newInstance = null
}

export default {
  install (vue) {
    vue.prototype.$toast = callback
  }
}